import styled from '@emotion/styled';
const breakpoints = {
    sm: 500,
    md: 768,
    lg: 992,
    xl: 1200,
};
const defaultTheme = {
    brandPrimary: '#fc2779',
    brandSecondary: '#ffd3e4',
    darkGrey: '#3f414d',
    lightGrey: '#8c8d94',
    darkGreen: '#5cd285',
    lightOrange: '#fa6400',
    brickColor: '#E02020',
    lightBorder: '#eeeeee',
    lightBlack: '#1b1b1b',
    fontFamily: 'sans-serif',
    breakpoints,
};
const mq = Object.keys(breakpoints)
    .map((key) => [key, breakpoints[key]])
    .reduce((prevObj, [key, breakpoint]) => {
    const prev = prevObj;
    prev[key] = `(min-width: ${breakpoint}px)`;
    return prev;
}, {});
export const getAppTheme = (theme) => (Object.assign(Object.assign(Object.assign({}, defaultTheme), theme), { mq }));
export default styled;
